import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import settingsGroupKey, { SettingsGroupKeyState } from './settings-group-keys/settings-group-key.store';
import settingsGroup, { SettingsGroupState } from './settings-groups/settings-group.store';
import { Setting } from './settings.interface';
import { SettingsService } from './settings.service';

const service = new SettingsService();

export interface SettingsState {
   settings: Array<Setting>;
   settingsGroup?: SettingsGroupState;
   settingsGroupKey?: SettingsGroupKeyState;
}

const SettingsStore: Module<SettingsState, StoreState> = {
   namespaced: true,
   state: { settings: [] },
   getters: { settings: (state) => state.settings },
   mutations: {
      SET_SETTINGS(state, settings: Array<Setting>) {
         state.settings = settings;
      },
   },
   actions: {
      async getSettings(context, query?: LocationQuery) {
         const response = await service.getSettings({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_SETTINGS', response.data);
         return response;
      },

      async getSetting(context, { id, query }: { id: number; query?: LocationQuery }) {
         const response = await service.getSetting(id, query);
         return response;
      },

      async createSetting(context, setting: Partial<Setting>) {
         const response = await service.createSetting(setting);
         return response;
      },

      async updateSetting(context, { id, setting }: { id: number; setting: Partial<Setting> }) {
         const response = await service.updateSetting(id, setting);
         return response;
      },

      async getSettingNxtJob(context, query?: LocationQuery) {
         const response = await service.getSettingNxtJob(query);
         return response;
      },
   },
   modules: {
      settingsGroup,
      settingsGroupKey,
   },
};

export default SettingsStore;
